<template>
<div class="beitreten">

    <!-- Schon in einer Sitzung (z.B. nach Neuladen oder Zurueck) -->
    <template v-if="schuelerSitzung.daten">
        <p class="pfad">Unterricht</p>
        <h1>Du bist in einer Sitzung</h1>
        <p class="hinweis">
            Dein Name in dieser Sitzung: <strong>{{ schuelerSitzung.daten.name }}</strong>
            <span class="leise">· Code {{ schuelerSitzung.daten.code }}</span>
        </p>
        <p v-if="schuelerSitzung.beendet" class="fehler" role="status">
            Die Sitzung ist beendet.
        </p>
        <div class="knoepfe">
            <button v-if="!schuelerSitzung.beendet" class="haupt" @click="weiter">Weiterarbeiten</button>
            <button @click="verlassen">Sitzung verlassen</button>
        </div>
    </template>

    <!-- Noch nicht beigetreten -->
    <form v-else @submit.prevent="beitreten">
        <p class="pfad">Unterricht</p>
        <h1>Sitzung beitreten</h1>
        <p class="hinweis">
            Gib den Code ein, den dein Ausbildner zeigt. Du bekommst einen Namen
            für diese Sitzung und arbeitest im eigenen Tempo.
        </p>
        <label class="feld">
            Code
            <input v-model="code" class="code" maxlength="6" autocomplete="off"
                   autocapitalize="characters" spellcheck="false" required />
        </label>
        <p v-if="fehler" class="fehler" role="alert">{{ fehler }}</p>
        <button type="submit" class="haupt" :disabled="laedt">Beitreten</button>
    </form>

</div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { schuelerSitzung, mitCodeBeitreten, verlassen } from '@/logic/sitzungSchueler'

// Je Thema die Ansicht, in der gearbeitet wird.
const ZIEL = {
    funk: 'SitzungFunk',
    sprechregeln: 'SitzungSprechregeln'
}

export default {
    setup() {
        const router = useRouter()
        const code = ref('')
        const fehler = ref('')
        const laedt = ref(false)

        const weiter = () => {
            router.push({ name: ZIEL[schuelerSitzung.daten.konfiguration.thema] })
        }

        const beitreten = async () => {
            fehler.value = ''
            laedt.value = true
            const ergebnis = await mitCodeBeitreten(code.value)
            laedt.value = false
            if (ergebnis.fehler) {
                fehler.value = ergebnis.fehler
                return
            }
            weiter()
        }

        return { schuelerSitzung, code, fehler, laedt, beitreten, weiter, verlassen }
    }
}
</script>

<style scoped>
/* Eine Tafel in der Seite, wie die Arbeitsflaeche der Uebungen. */
.beitreten {
    max-width: 560px;
    margin: 2.25rem 2.5rem 3rem;
    padding: 1.75rem 2rem 2rem;
    background: var(--zs-tafel);
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke-gross);
    box-shadow: var(--zs-schatten);
    text-align: left;
    color: var(--zs-tinte);
}

.pfad {
    margin: 0 0 0.35rem;
    font-size: 0.75rem;
    font-weight: 650;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--zs-grau);
}

h1 {
    margin: 0 0 0.5rem;
    font-size: 2rem;
    font-weight: 750;
    letter-spacing: -0.02em;
    color: var(--zs-tinte);
}

.hinweis {
    margin: 0 0 1.5rem;
    line-height: 1.5;
    color: var(--zs-grau);
}

.hinweis strong {
    color: var(--zs-tinte);
}

.leise {
    color: var(--zs-grau);
}

.feld {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    margin: 0 0 1.25rem;
    font-weight: 600;
}

/* Gross und gesperrt wie an der Wandtafel. */
.code {
    max-width: 240px;
    padding: 0.5rem 0.7rem;
    font: inherit;
    font-size: 1.8rem;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--zs-blau);
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    background: var(--zs-flaeche);
}

.code:focus-visible,
button:focus-visible {
    outline: 3px solid var(--zs-orange);
    outline-offset: 2px;
}

.knoepfe {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}

button {
    min-height: 2.75rem;
    padding: 0.6rem 1.4rem;
    font: inherit;
    font-weight: 600;
    color: var(--zs-tinte);
    background: #ffffff;
    border: 1px solid var(--zs-rahmen);
    border-radius: var(--zs-ecke);
    cursor: pointer;
}

/* Hauptaktion blau, wie ueberall in der App. */
.haupt {
    color: #ffffff;
    background: var(--zs-blau);
    border-color: var(--zs-blau);
}

.haupt:hover {
    background: var(--zs-blau-dunkel);
    border-color: var(--zs-blau-dunkel);
}

.haupt:disabled {
    opacity: 0.6;
    cursor: wait;
}

.fehler {
    margin: 0 0 1rem;
    padding: 0.6rem 0.8rem;
    border: 1px solid rgba(179, 38, 30, 0.3);
    border-radius: var(--zs-ecke);
    background: var(--zs-warnrot-hell);
    color: var(--zs-warnrot);
}

@media (max-width: 900px) {
    .beitreten {
        margin: 1.5rem 16px 2.5rem;
        padding: 1.25rem;
    }
}
</style>
